import React, { useState, useRef, useEffect, useCallback } from "react";
import LandingHeader from "component/Common/LandingHeader";
import LandingFooter from "component/Common/LandingFooter";
import ScrollContext from "context/scrollContext";
import { Helmet } from "react-helmet-async";
import CookiesBanner from "component/Landing/Home/CookiesBanner";
import DiscountBanner from "component/Landing/Home/DiscountBanner";

export const LandingLayout = (props) => {
  const appDemoScrollRef = useRef();
  const landingHeaderRef = useRef();
  const [shouldScroll, setShouldScroll] = useState(false);
  const [isCookiesBannerVisible, setIsCookiesBannerVisible] = useState(false);

  // On initial mount, check sessionStorage and set state
  useEffect(() => {
    if (sessionStorage.getItem("scrollToTarget")) {
      sessionStorage.removeItem("scrollToTarget");
      setShouldScroll(true);
    }
  }, []);

  // Watch for scrollRef being assigned AND scroll intent being true
  useEffect(() => {
    if (shouldScroll) {
      const interval = setInterval(() => {
        if (appDemoScrollRef.current) {
          handleScroll();
          setShouldScroll(false);
          clearInterval(interval);
        }
      }, 50);
      return () => clearInterval(interval);
    }
  }, [shouldScroll]);

  const handleScroll = () => {
    appDemoScrollRef?.current?.scrollToTarget(); // calling child method
  };

  const handleCookiesBannerVisibility = useCallback((visible) => {
    setIsCookiesBannerVisible(visible);
  }, []);

  return (
    <ScrollContext.Provider value={{ appDemoScrollRef, handleScroll }}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div className="w-full m-0">
        <LandingHeader handleScroll={handleScroll} landingHeaderRef={landingHeaderRef} />
        <>{props.children}</>
        <LandingFooter />
        {/* <DiscountBanner isCookiesBannerVisible={isCookiesBannerVisible} /> */}
        <CookiesBanner onVisibilityChange={handleCookiesBannerVisibility} />
      </div>
    </ScrollContext.Provider>
  );
};
